'use client';

import { Suspense } from 'react';

import { ErrorBoundary } from '@packages/shared';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';

import type { SlotProps } from '../Base/Slot';
import { Slot } from '../Base/Slot';
import { ServiceSlotMenuList } from '../Base/ServiceSlotMenuList';
import { useServiceLink } from '../../shared/useServiceLink';

/** Service slot with list of helpers in popover */
export const ServiceSlot = (props: Pick<SlotProps, 'priority'>) => {
  const { lifeSupportForBasicallyDeadTenant } = useConfig();
  const { href, label } = useServiceLink();

  return (
    <Slot
      {...props}
      useRouterLink={false}
      icon={<span className="icon-emp-service size-4" />}
      title={label}
      href={href}
      sx={{
        display: { xs: 'none', lg: 'initial' },
      }}
    >
      {lifeSupportForBasicallyDeadTenant ? null : (
        <ErrorBoundary>
          <Suspense>
            <ServiceSlotMenuList />
          </Suspense>
        </ErrorBoundary>
      )}
    </Slot>
  );
};
